module.exports = __webpack_public_path__ + "img/7dfa6e56d0ce06d7c20f843200b7da49.ee550a40.jpg";